import { render, staticRenderFns } from "./FaqEdit.vue?vue&type=template&id=bb6dfc42&scoped=true&"
import script from "./FaqEdit.vue?vue&type=script&lang=js&"
export * from "./FaqEdit.vue?vue&type=script&lang=js&"
import style0 from "./FaqEdit.vue?vue&type=style&index=0&id=bb6dfc42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6dfc42",
  null
  
)

export default component.exports